import { wrapper } from '../redux/store';
import '../style.css';
import '../helpers/FontAwesome';
import config from '../config';
import Datadog from '../components/Datadog/Datadog';

function MyApp({ Component, pageProps }) {
  return (
    <>
      {/* Datadog RUM is initialized here at the app root level (not in Layout) to:
             1. Capture all route changes including client-side navigation
             2. Track the initial page load properly
             3. Avoid re-initialization on each page render
             See: https://docs.datadoghq.com/real_user_monitoring/browser/ */}
      {config.dataDogEnabled === 'true' && <Datadog />}
      <Component {...pageProps} />
    </>
  );
}

// Only uncomment this method if you have blocking data requirements for
// every single page in your application. This disables the ability to
// perform automatic static optimization, causing every page in your app to
// be server-side rendered.
//
// MyApp.getInitialProps = async (appContext) => {
//   // calls page's `getInitialProps` and fills `appProps.pageProps`
//   const appProps = await App.getInitialProps(appContext);
//
//   return { ...appProps }
// }

export default wrapper.withRedux(MyApp);
